import React, { useEffect, useState } from 'react';
import "react-data-table-component-extensions/dist/index.css";
import { useFormik, Formik, Form, Field } from 'formik';
import { AddVenueSchema, EditVenueSchema } from './MastersSchema';
import { useDispatch, useSelector } from 'react-redux';
import { venueListRes, venueListTodo } from '../../LMS_Redux/LMS_Slices/Masters/VenueList';
import PropagateLoader from "react-spinners/PropagateLoader";
import { addUpdateVenueRes, addUpdateVenueTodo } from '../../LMS_Redux/LMS_Slices/Masters/AddUpdateVenue';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import VenueListAction from '../LMS_DATA_TABLE/ActionButtons/VenueList';
import { Spinner } from 'react-bootstrap';

export default function Venue() {

    const dispatch = useDispatch()
    const data = useSelector(state => state.venueList && state.venueList.data && state.venueList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [bool, setBool] = useState(false)
    const [editVenue, setEditVenue] = useState(false)
    const [edit, setEdit] = useState()
    // console.log(data)

    const initialValues = {
        venue: '',
        status: '',
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: AddVenueSchema,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateVenueTodo(values)).then(() => add_update_res(action))
        },
    })

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'VENUE',
            field: 'venue_name',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
            width: 300
        },
        {
            headerName: 'CREATED BY',
            field: 'created_by',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true
        },
        {
            field: 'ACTIONS',
            cellRenderer: VenueListAction,
            cellRendererParams: {
                editModal: setEditVenue,
                modalLoading: setModalLoading,
                editForm: setEdit,
            },
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    const venue_list_res = () => {
        if (venueListRes && venueListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const add_update_res = (action) => {
        if (addUpdateVenueRes && addUpdateVenueRes.success) {
            toast.success(addUpdateVenueRes.message, { position: "bottom-right" })
            setSpinner(false)
            setModalLoading(false)
            setEditVenue(false)
            setBool(!bool)
            action.resetForm()
        } else {
            toast.error(addUpdateVenueRes.message, { position: "bottom-right" })
            setSpinner(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(venueListTodo({ "status": '', "temp": 'list' })).then(() => venue_list_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Venue</span>
                </div>

                <div className='wrapper-admin mb-3'>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="venue" className="form-label form_label">Add Venue</label>
                                    <input type="text" className="form-control form_input" placeholder="Enter Venue Name" id='venue'
                                        name='venue' value={values.venue} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.venue && touched.venue ? (<span className='text-danger form_label'>{errors.venue}</span>) : null}
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <label htmlFor="status" className="form-label form_label">Status</label>
                                <select className="form-select form_input" aria-label="Default select example" id='status'
                                    name='status' value={values.status} onChange={handleChange} onBlur={handleBlur}
                                >
                                    <option value="">Select Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                                {errors.status && touched.status ? (<span className='text-danger form_label'>{errors.status}</span>) : null}
                            </div>

                            <div className='text-end mt-3'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }</button>
                            </div>
                        </div>
                    </form>
                </div>


                {loading ?
                    <div className='wrapper-admin mt-4'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }


                <div className={editVenue ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }} >
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Venue</h5>
                                <button type="button" className="btn-close" aria-label="Close" style={{ boxShadow: 'none' }} onClick={() => { setEditVenue(false); setEdit() }}></button>
                            </div>
                            <Formik
                                initialValues={{
                                    id: edit && edit.id || '',
                                    venue: edit && edit.venue_name || '',
                                    status: edit && edit.status || '',
                                }}
                                validationSchema={EditVenueSchema}
                                enableReinitialize
                                onSubmit={(values, action) => {
                                    // console.log(values);
                                    setModalLoading(true)
                                    dispatch(addUpdateVenueTodo(values)).then(() => add_update_res())
                                    action.resetForm();
                                }}
                            >
                                {({ errors, touched }) => (
                                    <Form>
                                        {modalLoading ?
                                            <div className="modal-body">
                                                <div className='text-center mb-3'>
                                                    <PropagateLoader
                                                        color="#2262C6"
                                                        size={20}
                                                    />
                                                </div>
                                            </div>
                                            :
                                            <>
                                                <div className="modal-body">
                                                    <div className="mb-3">
                                                        <label htmlFor='edit_venue' className="form-label">Venue Name</label>
                                                        <Field type="text" className="form-control form_input" placeholder="" name='venue' id='edit_venue' />
                                                        {errors.venue && touched.venue ? <span className='text-danger'>{errors.venue}</span> : null}
                                                    </div>
                                                    <div className="mb-3">
                                                        <label htmlFor='edit_status' className="form-label">Status</label>
                                                        <Field as="select" className="form-select form_input" aria-label="Default select example" name='status' id='edit_status'>
                                                            <option value=''>Select Status</option>
                                                            <option value="active">Active</option>
                                                            <option value="inactive">Inactive</option>
                                                        </Field>
                                                        {errors.status && touched.status ? <span className='text-danger'>{errors.status}</span> : null}
                                                    </div>
                                                </div>
                                                <div className="modal-footer">
                                                    {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                                    <button type="submit" className="btn btn_submit">Update</button>
                                                </div>
                                            </>
                                        }
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}